import { useQuery } from '@tanstack/react-query';
import { fetchGraphCategories } from '../services/graphApi';

export function useGraphCategoriesQuery(eventId: number | null) {
  return useQuery({
    queryKey: ['graph-categories', eventId],
    queryFn: () => fetchGraphCategories(eventId ?? 0),
    enabled: eventId != null,
  });
}
